<template>
  <!-- ========== FINALE CTA ========== -->
  <section class="cta-band reveal" id="cta">
    <h2>Dein nächstes gutes <span class="grad">Gespräch</span> wartet schon.</h2>
    <p>Kostenlos registrieren, Interessen wählen, Hallo sagen — mehr braucht es nicht.</p>
    <button type="button" class="cta-pill" data-open-signup>Kostenlos registrieren <span class="arrow">→</span></button>
  </section>
</template>

<script>
export default {
  name: 'KennenlernenCtaBand',
};
</script>
